import { render, staticRenderFns } from "./AllDocuments.vue?vue&type=template&id=6afb0f5f"
import script from "./AllDocuments.vue?vue&type=script&lang=ts"
export * from "./AllDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports